<template>
  <el-breadcrumb class="app-breadcrumb" separator="-">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span class="primaryTextColor" style="font-size: 14px;" v-if="item.redirect==='noredirect'||index==levelList.length-1">{{item.meta.title}}</span>
        <router-link class="primaryTextColor" style="font-size: 14px;" v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  // computed: {
  //   branchData() {
  //     return this.$store.state.user.branchData
  //       ? this.$store.state.user.branchData
  //       : {};
  //   },
  // },
  methods: {
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.name)
      // const first = matched[0]
      // if (first && first.name !== 'dashboard') {
      //   matched = [{ path: '/dashboard', meta: { title: 'Dashboard' }}].concat(matched)
      // }
      // console.log("branchData", this.$store.state.user.features)
      // const features = this.$store.state.user.features
      // let title = ''
      // const objectArray = Object.keys(features)
      // if (objectArray.length > 0) {
      //   for (let i = 0; i < objectArray.length; i++) {
      //     if (features[objectArray[i]]) {
      //       switch (objectArray[i]) {
      //         case 'syntomax': {
      //           title = 'Inventory Management System & TePaD'
      //           break
      //         }
      //         default: {
      //           title = 'Inventory Management System'
      //           break
      //         }
      //       }
      //       break
      //     }
      //   }
      // }
      this.levelList = [
        // {
        //   path: '/',
        //   meta: {
        //     title: title
        //   }
        // },
        ...matched
      ]
      // console.log(this.levelList)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue